(function(){
  'use strict';

  var categories = [
    {label:'Vibradores', handle:'vibradores'},
    {label:'Succionadores', handle:'succionadores-de-clitoris'},
    {label:'Anal', handle:'sexo-anal'},
    {label:'Masturbadores', handle:'masturbadores'},
    {label:'Lencería', handle:'lenceria'},
    {label:'Lubricantes', handle:'lubricantes'},
    {label:'Bondage', handle:'bondage'},
    {label:'Dildos', handle:'dildos'},
    {label:'Bombas', handle:'bomba-de-vacio'},
    {label:'Accesorios', handle:'accesorios'},
    {label:'Aceites y afrodisíacos', handle:'aceites-y-afrodisiacos'},
    {label:'Anillos', handle:'anillos-para-el-pene'},
    {label:'Disfraces', handle:'disfraces'},
    {label:'Juegos', handle:'juegos-de-mesa'}
  ];

  var running = false;

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function isCollectionPage(){
    return /^\/collections\/[^\/?#]+/.test(window.location.pathname || '');
  }

  function currentHandle(){
    var match = (window.location.pathname || '').match(/^\/collections\/([^\/?#]+)/);
    return match && match[1] ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function addStyles(){
    if (document.getElementById('erectus-filter-mobile-styles')) return;
    var style = document.createElement('style');
    style.id = 'erectus-filter-mobile-styles';
    style.textContent = [
      '@media (max-width:767px){',
      '.js-sidebar-mobile-content .title_sidebar h3{font-size:20px!important;letter-spacing:.08em!important;}',
      '.erectus-filter-categories{padding:22px 18px 18px!important;border-bottom:1px solid #ececec!important;background:#fff!important;}',
      '.erectus-filter-categories__title{margin:0 0 5px!important;color:#111!important;font-size:21px!important;font-weight:800!important;line-height:1.2!important;}',
      '.erectus-filter-categories__hint{margin:0 0 13px!important;color:#777!important;font-size:13px!important;line-height:1.35!important;}',
      '.erectus-filter-categories__grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:8px!important;}',
      '.erectus-filter-category{display:flex!important;align-items:center!important;justify-content:center!important;min-height:42px!important;padding:8px 7px!important;border:1px solid #e4e4e4!important;border-radius:9px!important;background:#fff!important;color:#222!important;text-align:center!important;text-decoration:none!important;font-size:12.5px!important;font-weight:650!important;line-height:1.2!important;box-sizing:border-box!important;}',
      '.erectus-filter-category:hover,.erectus-filter-category:focus{color:#222!important;text-decoration:none!important;}',
      '.erectus-filter-category.is-active{border-color:#d90000!important;background:#fff4f4!important;color:#d90000!important;font-weight:800!important;}',
      '.erectus-filter-category.is-extra{display:none!important;}',
      '.erectus-filter-categories.is-expanded .erectus-filter-category.is-extra{display:flex!important;}',
      '.erectus-filter-categories__more{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;min-height:40px!important;margin:7px 0 0!important;padding:5px!important;border:0!important;background:transparent!important;color:#d90000!important;font-size:13px!important;font-weight:800!important;}',
      '.erectus-filter-categories__more:after{content:"›"!important;margin-left:6px!important;font-size:19px!important;line-height:1!important;transform:rotate(90deg)!important;}',
      '.erectus-filter-categories.is-expanded .erectus-filter-categories__more:after{transform:rotate(-90deg)!important;}',
      '.erectus-hide-filter-block{display:none!important;}',
      '.content-sidebar.sidebar-detail>.layer-navigation{padding-left:18px!important;padding-right:18px!important;}',
      '.content-sidebar.sidebar-detail>.layer-navigation .layer-navigation__head h5{font-size:17px!important;font-weight:800!important;text-transform:none!important;}',
      '}',
      '@media (max-width:360px){.erectus-filter-category{font-size:12px!important;padding-left:5px!important;padding-right:5px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function cleanText(value){
    return (value || '').replace(/\s+/g,' ').trim().toLowerCase();
  }

  function isEmptyLegacyBlock(block){
    var text = cleanText(block.textContent);
    return text.indexOf('no hay colecciones') !== -1 ||
      text.indexOf('no hay etiquetas') !== -1 ||
      text.indexOf('no hay colores') !== -1 ||
      text.indexOf('no collections') !== -1 ||
      text.indexOf('no tags') !== -1 ||
      text.indexOf('no colors') !== -1;
  }

  function translateLegacyTitle(block){
    var heading = block.querySelector('.layer-navigation__head h5');
    if (!heading) return;
    var text = cleanText(heading.textContent);
    var label = '';
    if (text.indexOf('product categories') === 0 || text === 'collections') label = 'Categorías';
    else if (text.indexOf('filter by brands') === 0 || text === 'brands') label = 'Marca';
    else if (text.indexOf('filter bycolor') === 0 || text.indexOf('filter by color') === 0) label = 'Color';
    else if (text.indexOf('filter by price') === 0) label = 'Precio';
    else if (text.indexOf('filter by size') === 0) label = 'Talla';
    if (!label) return;
    var icon = heading.querySelector('i');
    heading.textContent = label + ' ';
    if (icon) heading.appendChild(icon);
  }

  function buildCategories(content){
    var existing = document.getElementById('erectus-filter-categories');
    if (existing) return existing;

    var box = document.createElement('section');
    box.id = 'erectus-filter-categories';
    box.className = 'erectus-filter-categories';

    var title = document.createElement('h4');
    title.className = 'erectus-filter-categories__title';
    title.textContent = 'Categorías';
    box.appendChild(title);

    var hint = document.createElement('p');
    hint.className = 'erectus-filter-categories__hint';
    hint.textContent = 'Elige lo que quieres ver';
    box.appendChild(hint);

    var grid = document.createElement('div');
    grid.className = 'erectus-filter-categories__grid';
    var current = currentHandle();

    categories.forEach(function(category, index){
      var link = document.createElement('a');
      link.className = 'erectus-filter-category' + (index >= 8 ? ' is-extra' : '');
      link.href = '/collections/' + category.handle;
      link.textContent = category.label;
      if (current === category.handle) {
        link.classList.add('is-active');
        link.setAttribute('aria-current','page');
      }
      grid.appendChild(link);
    });

    box.appendChild(grid);

    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'erectus-filter-categories__more';
    more.textContent = 'Más categorías';
    more.setAttribute('aria-expanded','false');
    more.addEventListener('click', function(){
      var expanded = box.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      more.textContent = expanded ? 'Ver menos' : 'Más categorías';
    });
    box.appendChild(more);

    var firstBlock = content.querySelector('.layer-navigation');
    if (firstBlock) content.insertBefore(box, firstBlock);
    else content.appendChild(box);
    return box;
  }

  function enhance(){
    if (running || !isMobile() || !isCollectionPage()) return;
    running = true;
    try {
      var content = document.querySelector('.js-sidebar-mobile-content .content-sidebar.sidebar-detail') || document.querySelector('.content-sidebar.sidebar-detail');
      if (!content) return;

      addStyles();
      var heading = document.querySelector('.js-sidebar-mobile-content .title_sidebar h3') || document.querySelector('.title_sidebar h3');
      if (heading) heading.textContent = 'FILTRAR';

      var blocks = content.querySelectorAll('.layer-navigation');
      Array.prototype.forEach.call(blocks, function(block){
        translateLegacyTitle(block);
        if (isEmptyLegacyBlock(block)) block.classList.add('erectus-hide-filter-block');
        else block.classList.remove('erectus-hide-filter-block');
      });

      buildCategories(content);
    } finally {
      running = false;
    }
  }

  function queue(){
    window.setTimeout(enhance, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();

  document.addEventListener('click', function(event){
    if (event.target && event.target.closest && event.target.closest('.js-mobile-sidebar')) queue();
  }, true);
  document.addEventListener('collection:updated', queue);
  document.addEventListener('shopify:section:load', queue);

  var observer = new MutationObserver(function(mutations){
    var relevant = mutations.some(function(m){ return m.addedNodes && m.addedNodes.length; });
    if (relevant && isMobile() && isCollectionPage()) queue();
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
